import { TAX_DETAILS } from '@/core/field-names';

/**
 * Filtering fields that will only contribute to tax details
 * document completion.
 * @param fieldValueMap {Object}
 * @param fieldValueMap.value {Any}
 * @param fieldValueMap.required {Boolean}
 * @param fieldValueMap.errorList {String[]}
 * @returns {String[]}
 */
export function filterTaxDetailsToBeIncluded(fieldValueMap) {
  const isInsuranceNumberEmpty = Boolean(
    !fieldValueMap[TAX_DETAILS.NATIONAL_INSURANCE_NUMBER].value
  );

  fieldValueMap[TAX_DETAILS.STUDENT_LOAN]?.value === 'Yes';

  const hasStudentLoan =
    fieldValueMap[TAX_DETAILS.STUDENT_LOAN]?.value === 'Yes';

  const hasP45 = fieldValueMap[TAX_DETAILS.P45]?.value === 'Yes';

  const taxDetailsRule = {
    [TAX_DETAILS.NATIONAL_INSURANCE_NUMBER]: !isInsuranceNumberEmpty,
    [TAX_DETAILS.REASON]: true,
    [TAX_DETAILS.STUDENT_LOAN]: true,
    [TAX_DETAILS.LOAN_PLANS]: hasStudentLoan,
    [TAX_DETAILS.P45]: true,
    [TAX_DETAILS.P45_UPLOAD]: hasP45,
    [TAX_DETAILS.DECLARATION]: true,
  };

  return Object.keys(taxDetailsRule).filter((key) => {
    return taxDetailsRule[key];
  });
}
